<cv-dropdown-button
	class="available-pdf-button"
	[label]="isLoading ? 'Downloading': 'Available PDF'"
	[disabled]="isLoading"
	[icon]="'fa-file-pdf'"
	[position]="'down'"
	[buttonClass]="'btn-sm cv-btn-light'"
	[items]="availablePdf"
	(menuOpened)="loadOrderAvailablePdf()"
	(subOptionClick)="downloadAvailablePdf($event)"
>
</cv-dropdown-button>
